import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['form', 'interstitial', 'results'];

  async search(event) {
    event.preventDefault();

    const body = new FormData(event.target);

    if (this.shouldConfirm && !window.confirm(this.confirmationMessage)) {
      return;
    }

    this.interstitialTarget.classList.remove(this.hiddenClass);
    this.formTarget.classList.add(this.hiddenClass);

    await fetch(event.target.action, { method: 'POST', body })
      .then(response => response.text())
      .then(html => {
        const fragment = document.createRange().createContextualFragment(html);
        this.resultsTarget.replaceChildren();
        this.resultsTarget.appendChild(fragment);

        this.resultsTarget.classList.remove(this.hiddenClass);
        this.interstitialTarget.classList.add(this.hiddenClass);
      });
  }

  showForm(event) {
    event.preventDefault();
    this.resultsTarget.classList.add(this.hiddenClass);
    this.formTarget.classList.remove(this.hiddenClass);
  }

  get hiddenClass() {
    return this.data.get('hidden-class');
  }

  get shouldConfirm() {
    return this.data.get('confirm') === 'enabled';
  }

  get confirmationMessage() {
    return this.data.get('confirmation-message') || 'Please confirm';
  }
}
